<template>
  <div class="home h-100">
    <!-- Navigation -->
    <Navbar />
    <section class="hero-header h-100">
      <div class="container">
            <div class="description text-center" data-aos="fade-down">
                <h1 class="">Come work with us</h1>
                <p class="">Build your dream career by working with us to help our clients build their dream life</p>
            </div>
        </div>
    </section>

    <!-- why work with us -->
    <section class="why">
      <div class="container">
        <div class="row">
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <div class="why-text" data-aos="fade-up">
                  <h3>Why work with us?</h3>
                  <p>How would you like to join a team of smart, ambitious and motivated people making a difference in the lives of others by helping them to build wealth? What we offer you is an opportunity to learn, grow, and be part of something big.
</p>
              </div>
          </div>
        </div>
      </div>
    </section>

    <!-- careers images section -->
    <!-- <section class="gallery">
      <div class="container">
          <div class="row">
            <div class="col-md-7">
              <div class="img-wrapper" data-aos="fade-up">
                <img src="/img/careers/careers1.svg" class="img-fluid" alt="">
              </div>
            </div>
            <div class="col-md-5">
             <div class="img-wrapper" data-aos="fade-up">
                <img src="/img/careers/careers2.svg" class="img-fluid" alt="">
              </div>
            </div>
            <div class="col-md-5">
              <div class="img-wrapper" data-aos="fade-up">
                <img src="/img/careers/careers3.png" class="img-fluid" alt="">
              </div>
            </div>
            <div class="col-md-7">
              <div class="img-wrapper" data-aos="fade-up">
                <img src="/img/careers/careers4.png" class="img-fluid" alt="">
              </div>
            </div>
          </div>
      </div>
    </section> -->

    <!-- job openings -->
    <section class="job-openings" id="job">
      <div class="container">
        <h3 data-aos="fade-up">Job Openings</h3>
        <div class="job-wrapper">
          <div class="row" data-aos="fade-up">
            <div class="col-md-3">
              <h5>Vale Finance</h5>
            </div>
            <div class="col-md-9">
              <div class="row position-wrap">
                <div class="col-md-4">
                  <small>Digital Marketing Coordinator</small>
                </div>
                <div class="col-md-5">
                  <div class="row"> 
                    <div class="col-6">
                      <small>Full time</small>
                    </div>
                    <div class="col-6 lagos">
                      <small>Lagos</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 more">
                  <a @click="$router.push({ name: 'digitalMarketCoordinator'})" href="#" class="btn btn-primary">Learn More</a>
                </div>
              </div>
              <div class="row position-wrap-inner">
                <div class="col-md-4">
                  <small>Direct Sales Representative</small>
                </div>
                <div class="col-md-5">
                  <div class="row"> 
                    <div class="col-6">
                      <small>Full time</small>
                    </div>
                    <div class="col-6 lagos">
                      <small>Lagos</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 more">
                  <a @click="$router.push({ name: 'directSalesRep'})" href="#" class="btn btn-primary">Learn More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import Navbar from "../components/Navbar.vue";

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .hero-header {
      background-image: url("../../public/img/careers-hero-header.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding-top: 10rem;

      .description {
          color: #fff;

          h1 {
              font-family: 'Poppins', sans-serif;
              font-weight: bold;
              font-size: 64px;
              line-height: 96px;
              letter-spacing: 0.02em;
          }

          p {
              font-family: 'Poppins', sans-serif;
              font-size: 22px;
              line-height: 32px;
              padding: 0 15rem;
              text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          }
      }
  }

  // why styles
  h3 {
    font-weight: bold;
    font-size: 32px;
    line-height: 60px;
    letter-spacing: 0.02em;
    color: map-get($colors, deep-blue);
  }
  .why {
    padding: 2rem 0 4rem;

    .why-text {

      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: px;
        color: #2C3C90;;
      }
    }
  }

  // gallery
  .gallery { 
    .img-wrapper {
      margin-bottom: 2rem;
      border-radius: 16px;
    }
  }


  // Job openings
  .job-openings {
    padding: 2rem 0;

    .job-wrapper {
      background: #D8DCF3;
      border-radius: 8px;
      padding: 1.5rem;
      margin-bottom: 4rem;

      h5 {
        font-weight: bold;
        font-size: 17px;
        line-height: 33px;
        letter-spacing: 0.02em;
        
      }

      .position-wrap, .position-wrap-inner, .role {
        font-family: Poppins;
        padding: 0.6rem 0;
        align-items: center;
      }

      .position-wrap {
        margin-bottom: 0.6rem;

        &:hover {
          background: #FFFFFF;
          box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
          border-radius: 8px;
        }
      }

      .role {
        padding: 0.6rem 0 1rem;

      }

      .role, .position-wrap-inner {
         &:hover {
           background: #FFFFFF;
          box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
          border-radius: 8px;
         }
      }

      hr {
        border: 1px solid #F1F3F4;
        margin: 1rem 0 1rem 0;
      }

      .btn {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      }

    }

  }

  @media (min-width: 992px) and (max-width: 1199px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 64px;
                line-height: 96px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 10rem;
            }
        }
    }

    .why {
      padding: 0 0 4rem;
      margin-top: -1rem;
    }

  }


  @media (min-width: 767px) and (max-width: 991px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 52px;
                line-height: 76px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 5rem;
            }
        }
    }

    .why {
      margin-top: -4rem;
    }

    h3 {
      font-size: 24px;
    }

    .job-openings {
      padding: 2rem 0;

      .job-wrapper {

        h5 {
          font-size: 14px;
          
        }

        small {
          font-size: 75%;
        }

        .btn {
          font-size: 12px;
          padding-left: 0.6rem;
          padding-right: 0.6rem;
        }

      }

    }
  }

  @media (max-width: 767px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 42px;
                line-height: 57px;
            }

            p {
                font-size: 20px;
                line-height: 32px;
                padding: 0 3rem;
            }
        }
    }

    h3 {
      font-size: 24px;
    }

    .why {
      margin-top: -4rem;
    }

    .job-openings {
      padding: 1rem 0 2rem;

      .job-wrapper {

        h5 {
          font-size: 14px;
          
        }

        .position-wrap {
          background: #FFFFFF;
          box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
          border-radius: 8px;
        }

        .lagos {
          margin-left: -4rem;
        }

        .more {
          display: flex;
          justify-content: flex-end;
        }

        small {
          font-size: 75%;
        }

        .btn {
          font-size: 12px;
          padding-left: 0.6rem;
          padding-right: 0.6rem;
          margin-top: -1.5rem;
        }

        hr {
          display: none;
        }

        .role, .position-wrap-inner {
        background: #FFFFFF;
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
        border-radius: 8px;
        margin-bottom: 0.8rem;
      }


      }

    }

    
  }

  @media (max-width: 575px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        //padding-top: 6rem;

        .description {

            h1 {
                line-height: 46px;
            }

        }
    }

    
  }

  @media (max-width: 375px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");

        .description {

            h1 {
                font-size: 35px;
            }

            p {
                font-size: 17px;
                padding: 0 2rem;
            }
        }
    }

    
  }


</style>

